export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/house.9c472c8.svg";